// extracted by mini-css-extract-plugin
export default {"termsModal":"TermsAndConditions_termsModal__lqqOW"};